import React from 'react';
import {connect} from "react-redux";
import moment from "moment";

const NotificationsButtonAlertsMessages = (props) => {

  const {dropdownMessages} = props;

  return (
    <div className="header-alerts__modal bg-white color-blue radius-10 p-1 absolute mt-05">
      <h5 className="bold font--14 text-uppercase text-center mb-075 mt-0">Latest Messages</h5>
      <ul className="fix-ul text-left">
        {dropdownMessages.map((message, messageIndex) => {
          return (
            <li className={(messageIndex === dropdownMessages.length - 1 ? "" : "bordered mb-075 pb-075")} key={message.id}>
              <span className="bold font--14">{moment(message.date).format('MM/DD/YYYY')}</span>
              <p className="m-0 font--14">{message.message}</p>
            </li>
          )
        })}
      </ul>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    notificationsCount: store.dashboardState.notificationsCount,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsButtonAlertsMessages);
